<template>
    <div>
        <div v-if="showDanger" class="alert alert-danger alert-dismissible fade show" role="alert">
            {{text}}
            <button style="outline:0" type="button" class="close" data-dismiss="alert" aria-label="Fechar alerta" @click="showDanger = false">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</template>
<script>
import bus from '@/service/bus'
export default {
    data(){
        return {
            text: '',
            showDanger: ''
        }
    },
    mounted(){
        bus.$on('alert-danger', (text)=>{
            this.text = text
            this.showDanger = true
        })
        bus.$on('close-alert', ()=>{
            this.showDanger = false
        })
    },
    beforeDestroy() {
        bus.$off('alert-danger')
        bus.$off('close-alert')
    },
}
</script>